export interface PlatformTransactionDto {
  ticket: number
  login: number
  symbol: string
  type: {
    id: number
    name: 'Buy' | 'Sell'
  }
  openTime: string
  closeTime: string
  volume: number
  openPrice: number
  closePrice: number
  stopLoss: null | number
  takeProfit: null | number
  profit: number
  commission: number
  commissionAgent: number
  swaps: number
  comment: string
}

export enum PlatformTransactionKey {
  ticket = 'ticket',
  login = 'login',
  symbol = 'symbol',
  type = 'type',
  openTime = 'openTime',
  closeTime = 'closeTime',
  volume = 'volume',
  openPrice = 'openPrice',
  closePrice = 'closePrice',
  stopLoss = 'stopLoss',
  takeProfit = 'takeProfit',
  profit = 'profit',
  commission = 'commission',
  commissionAgent = 'commissionAgent',
  swaps = 'swaps',
  comment = 'comment',
  platform = 'tradingAccountPlatformType',
}

export enum PlatformTransactionFilterKey {
  symbol = 'Symbol',
  openTime = 'OpenTime',
}
